import type { LoaderFunction } from 'react-router-dom';
import { apiListCintureForAlbo } from "../../api/beltApi";
import { combineAdminLoader } from "./AdminRouteProtection";

const HallOfFameHandlerLoaderInternal: LoaderFunction = async () => {
    try {
        const response = await apiListCintureForAlbo();
        return response;
    } catch (error) {
        throw new Error('Failed to load belts for hall of fame');
    }
};

// Wrapper con protezione admin
export const HallOfFameHandlerLoader: LoaderFunction = combineAdminLoader(HallOfFameHandlerLoaderInternal);
